// B2BIndicatorsMenu.js
import React from 'react';
import { AddCircle, AutoAwesomeMosaic, Category, DeveloperBoard, GitHub, Info, InsightsOutlined, OutlinedFlag, SquareFoot, StackedLineChart, Straighten, Toll, ViewList } from '@mui/icons-material';
import CustomMenu from '../layout/components/CustomMenu';
import useMenuItemClick from '../layout/hooks/useMenuItemClick';

const B2BIndicatorsMenu = ({ handleLogout, onItemSelected = null }) => {
    const handleItemClick = useMenuItemClick(onItemSelected);

    const menuItems = [
        {
            label: 'Organization Custom Indicators',
            icon: <InsightsOutlined />,
            items: [
                {
                    label: 'Explorer.', icon: <OutlinedFlag />, onClick: () => {
                        handleItemClick('/indicators/custom-explorer');
                    },
                },
                { label: 'List organization custom indicators.', icon: <ViewList />, onClick: handleLogout },
                { label: 'Add a new organization custom indicator.', icon: <AddCircle />, onClick: handleLogout, divider: false },
            ],
        },
        {
            label: 'Quantitative',
            icon: <SquareFoot />,
            rolesAllowed: ['ROLE_SUPER_ADMIN'],
            items: [
                { label: 'List quantitative product indicators.', icon: <ViewList />, onClick: handleLogout, divider: true },
                {
                    label: 'Measurement units.', icon: <Straighten />, onClick: () => {
                        handleItemClick('/indicators/measurement-units');
                    },
                },
                {
                    label: 'Measurement units categories.', icon: <Category />, onClick: () => {
                        handleItemClick('/indicators/mu-categories');
                    },
                },
            ],
        },
        {
            label: 'Qualitative',
            icon: <Toll />,
            rolesAllowed: ['ROLE_SUPER_ADMIN'],
            items: [
                { label: 'List qualitative product indicators.', icon: <ViewList />, onClick: handleLogout, divider: true },
                {
                    label: 'Qualitative types defined.', icon: <DeveloperBoard />, onClick: () => {
                        handleItemClick('/indicators/qual-types');
                    },
                },
            ],

        },
        {
            label: 'Dimensional',
            icon: <StackedLineChart />,
            rolesAllowed: ['ROLE_SUPER_ADMIN'],
            items: [
                { label: 'List dimensional product indicators.', icon: <ViewList />, onClick: handleLogout, divider: true },
                { label: 'Dimension sets defined.', icon: <AutoAwesomeMosaic />, onClick: handleLogout },
            ],
        },
        {
            label: 'GIT Info',
            icon: <GitHub />,
            rolesAllowed: ['ROLE_SUPER_ADMIN'],
            items: [
                {
                    label: 'Show GIT commit info.', icon: <Info />, onClick: () => {
                        handleItemClick('/indicators/git-info');
                    },
                },
            ],
        },
    ];

    return (
        <CustomMenu title="Indicators Menu"
            rolesAllowed={null}
            menuItems={menuItems} />
    );
};

export default B2BIndicatorsMenu;
